<template>
  <b-modal
    v-model="visibleProxy"
    :title="modalTitle"
    size="lg"
    ok-only
    ok-title="Close"
    scrollable
    @hidden="$emit('hidden')"
  >
    <div v-if="!updates || !updates.length" class="text-muted py-2">
      No overlap correction details recorded.
    </div>

    <div v-else>
      <div
        v-for="(update, idx) in sortedUpdates"
        :key="'overlap-update-' + idx"
        class="overlap-update-entry"
      >
        <div class="overlap-update-header">
          <span class="overlap-update-time">{{ formatProcessedTime(update.processed_time) }}</span>
          <span v-if="update.trigger" class="overlap-update-trigger">{{ formatTrigger(update.trigger) }}</span>
        </div>

        <div v-if="update.context && update.context.length" class="overlap-update-context">
          <div v-for="(ctx, ctxIdx) in update.context" :key="'ctx-' + idx + '-' + ctxIdx" class="ctx-row">
            <span v-if="ctx.event"><b>Event:</b> {{ ctx.event }}</span>
            <span v-if="ctx.lane">&nbsp;|&nbsp;<b>Lane:</b> {{ ctx.lane }}</span>
            <span v-if="ctx.boundary_iso">&nbsp;|&nbsp;<b>Boundary:</b> {{ ctx.boundary_iso }}</span>
            <span v-if="ctx.boundary_source">&nbsp;|&nbsp;<b>Source:</b> {{ ctx.boundary_source }}</span>
            <span v-if="ctx.peer_booking_id">&nbsp;|&nbsp;<b>Peer:</b> {{ ctx.peer_booking_id }}</span>
            <span v-if="ctx.movement_id">&nbsp;|&nbsp;<b>Movement:</b> {{ ctx.movement_id }}</span>
            <span v-if="ctx.driver_name">&nbsp;|&nbsp;<b>Driver:</b> {{ ctx.driver_name }}</span>
          </div>
        </div>

        <div v-if="mappedChanges(update.changes).length" class="chg-view">
          <div v-for="(change, changeIdx) in mappedChanges(update.changes)" :key="'chg-' + idx + '-' + changeIdx" class="chg-row">
            <div class="chg-label">{{ change.label }}</div>
            <div class="chg-val">
              <span class="chg-old">{{ change.old }}</span>
              <span class="chg-arrow">&rarr;</span>
              <span class="chg-new">{{ change.new }}</span>
              <div v-if="change.sourceText" class="chg-source">{{ change.sourceText }}</div>
            </div>
          </div>
        </div>
        <div v-else class="text-muted overlap-update-empty">No field changes recorded.</div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  formatOverlapTrigger,
  formatOverlapProcessedTime,
  mapOverlapChanges,
} from '@/helpers/overlap_updates_format'

export default {
  name: 'actuals_overlap_updates_modal',

  props: {
    visible: { type: Boolean, default: false },
    bookingLabel: { type: String, default: '' },
    updates: { type: Array, default: () => [] },
  },

  computed: {
    visibleProxy: {
      get() { return this.visible },
      set(v) { this.$emit('update:visible', v) },
    },
    modalTitle() {
      const label = (this.bookingLabel || '').trim()
      return label ? ('Overlap corrections — ' + label) : 'Overlap corrections'
    },
    sortedUpdates() {
      return [...(this.updates || [])].sort((a, b) => {
        const aTime = a.processed_time || ''
        const bTime = b.processed_time || ''
        return bTime.localeCompare(aTime)
      })
    },
  },

  methods: {
    formatTrigger: formatOverlapTrigger,
    formatProcessedTime: formatOverlapProcessedTime,
    mappedChanges: mapOverlapChanges,
  },
}
</script>

<style scoped>
.overlap-update-entry {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 10px 12px;
  margin-bottom: 12px;
  background: #fafafa;
}
.overlap-update-header {
  font-weight: 600;
  margin-bottom: 8px;
}
.overlap-update-time {
  margin-right: 8px;
}
.overlap-update-trigger {
  color: #495057;
  font-weight: 500;
}
.overlap-update-context {
  margin-bottom: 8px;
}
.overlap-update-empty {
  font-size: 13px;
}
.chg-view { font-size: 13px; }
.chg-row { display: flex; gap: 14px; padding: 6px 0; align-items: baseline; border-bottom: 1px solid #f0f0f0; }
.chg-row:last-child { border-bottom: none; }
.chg-label { flex: 0 0 220px; font-weight: 600; color: #333; word-break: break-word; }
.chg-val { flex: 1; min-width: 0; word-break: break-word; }
.chg-old { color: #c62828; text-decoration: line-through; }
.chg-new { color: #2e7d32; }
.chg-arrow { margin: 0 8px; color: #888; }
.chg-source { font-size: 11px; color: #666; margin-top: 2px; }
.ctx-row { font-size: 13px; margin-bottom: 4px; }
</style>
